<template>
  <div class="text-divider">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppTextDivider',
  props: {
    variant: {
      type: String,
      default: 'solid',
    },
    color: {
      type: String,
      default: 'rgb(var(--v-theme-grey-100))',
    },
  },
})
</script>

<style lang="scss" scoped>
.text-divider {
  --text-divider-gap: 8px;
  align-items: center;
  color: rgb(var(--v-theme-grey-500));
  display: flex;

  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    height: 0;
    border-bottom: 1px v-bind(variant) v-bind(color);
  }

  &::before {
    margin-right: var(--text-divider-gap);
  }

  &::after {
    margin-left: var(--text-divider-gap);
  }

  &.default {
    &::before,
    &::after {
      border-bottom-style: solid;
    }
  }

  &.dashed {
    &::before,
    &::after {
      border-bottom-style: dashed;
    }
  }
}
</style>
